import { MembershipRole } from '@/types/api/membership';
import MembershipRoleBadge from './membership-role-badge';

interface MembershipRolesDisplayProps {
  roles: MembershipRole[];
}

export default function MembershipRolesDisplay({ roles }: MembershipRolesDisplayProps) {
  return (
    <div className="flex -space-x-2">
      {roles.map((role, index) => (
        <MembershipRoleBadge role={role} key={index} />
      ))}
    </div>
  );
}
